import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const VirtualConnectionQueryGql: DocumentNode = gql`
query VirtualConnectionQuery($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}, permissionMode: FILTER_RESULTS) {
    name
    tables (orderBy: { field: NAME, direction: ASC}) {
      name
      id
    }
  }
}
`;
